import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { FetchAssetParams, FulfillmentContext } from '../types';
import parseStatusCode from '../../errors/parseStatusCode';

export interface FulfillmentContextModel {
  fetchFulfillmentContexts: Thunk<FulfillmentContextModel, FetchAssetParams, Injections, Promise<FulfillmentContext[]>>;
  fetchFulfillmentContext: Thunk<FulfillmentContextModel, string, Injections, Promise<FulfillmentContext>>;
  fulfillmentContextActionStart: Action<FulfillmentContextModel, void>;
  lastAction?: number;
  fulfillmentContexts: Record<string, FulfillmentContext>;
  fulfillmentContextFailure: Action<FulfillmentContextModel, ApplicationErrorOptions>;
  setFulfillmentContexts: Action<FulfillmentContextModel, FulfillmentContext[]>;
}

export const fulfillmentContextModel: FulfillmentContextModel = {
  fulfillmentContexts: {},
  fulfillmentContextFailure: action((state, payload) => {
    console.error(payload);
  }),
  setFulfillmentContexts: action((state, payload) => {
    for (const val of payload) {
      state.fulfillmentContexts[val.fulfillmentContextId] = val;
    }
  }),
  fulfillmentContextActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  fetchFulfillmentContexts: thunk(async (actions, payload, { injections }) => {
    try {
      actions.fulfillmentContextActionStart();
      const res = await injections.assetService.fetchFulfillmentContexts(payload);
      actions.setFulfillmentContexts(res);
      return res;
    } catch (error) {
      actions.fulfillmentContextFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching fulfillment contexts',
        asNotification: true,
      });
    }
  }),
  fetchFulfillmentContext: thunk(async (actions, payload, { injections }) => {
    try {
      actions.fulfillmentContextActionStart();
      const res = await injections.assetService.fetchFulfillmentContext(payload);
      actions.setFulfillmentContexts([res]);
      return res;
    } catch (error) {
      actions.fulfillmentContextFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching fulfillment context',
        asNotification: true,
      });
    }
  }),
};
